var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEncryption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_607_2441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_607_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 17.15L18.0002 15.15V10H12.8502L10.8502 8H15.0002V6C15.0002 5.16667 14.7127 4.45833 14.1377 3.875C13.5627 3.29167 12.8585 3 12.0252 3C11.1919 3 10.4919 3.2875 9.9252 3.8625C9.35853 4.4375 9.0752 5.15 9.0752 6V6.225L7.2502 4.4C7.61686 3.38333 8.24186 2.5625 9.1252 1.9375C10.0085 1.3125 10.9752 1 12.0252 1C13.4085 1 14.5835 1.4875 15.5502 2.4625C16.5169 3.4375 17.0002 4.61667 17.0002 6V8H18.0002C18.5502 8 19.021 8.19583 19.4127 8.5875C19.8044 8.97917 20.0002 9.45 20.0002 10V17.15ZM20.5002 23.3L18.9502 21.75C18.7669 21.8333 18.6002 21.8958 18.4502 21.9375C18.3002 21.9792 18.1502 22 18.0002 22H6.0002C5.4502 22 4.97936 21.8042 4.5877 21.4125C4.19603 21.0208 4.0002 20.55 4.0002 20V10C4.0002 9.58333 4.12103 9.2 4.3627 8.85C4.60436 8.5 4.91686 8.25 5.3002 8.1L0.700195 3.5L2.1002 2.1L21.9002 21.9L20.5002 23.3ZM17.1502 20L13.4752 16.275C13.2919 16.4583 13.0794 16.6 12.8377 16.7C12.596 16.8 12.3335 16.85 12.0502 16.85C11.5002 16.85 11.0294 16.6542 10.6377 16.2625C10.246 15.8708 10.0502 15.4 10.0502 14.85C10.0502 14.5667 10.1002 14.3042 10.2002 14.0625C10.3002 13.8208 10.4419 13.6083 10.6252 13.425L7.1502 10H6.0002V20H17.1502Z",
    fill: "#ABAFB1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEncryption);
export default __webpack_public_path__ + "static/media/no-encryption.dbc266f682327a205f492ec1c9d062b9.svg";
export { ForwardRef as ReactComponent };